export default __webpack_public_path__ + "static/media/intruder-alert.fb52bf08.jpg";